<template>
  <div>
    <b-row>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="12"
          xl="12"
      >

        <b-col
            cols="12"
        >
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0 mb-2"
          />
        </b-col>

        <b-card-code
            v-for="item in items"
        >
          {{formatDate(item.Created)}} (<timeago :datetime="item.Created" locale="de" :auto-update="60"></timeago>)

          <div
              v-for="l in item.TextList"
          >
            <b-row class="float-right">{{l.User}} -  {{formatDate(l.Created)}} (<timeago :datetime="l.Created" locale="de" :auto-update="60"></timeago>)</b-row>
            <div v-html="l.Text"></div>
            <b-row style="background-color: #e70e36; height: 0.01vh;" class="mt-1"></b-row>
          </div>
        </b-card-code>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BBadge, BDropdown, BButton, BFormInput, BPagination, BFormSelect, BCol, BFormGroup, BInputGroupAppend, BInputGroup, BRow, BTable, BAlert, BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'

export default {
  components: {
    BCardCode,
    BButton,
    BRow,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'Note',
          label: 'Eintrag',
        },
      ],
      items: [],
    }
  },
  mounted() {
    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )

    this.$nextTick(() => {
      document.title = 'Notizblock'
    })
    this.LoadList();
  },
  methods: {
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/note/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/note/list/filter?filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            if (resp.data.success) {
              this.totalRows = resp.data.info.fullEntries
              resp.data.list.forEach(i => {
                this.items.push(i)
              })
            }

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>

<style scoped>

</style>